import { render, staticRenderFns } from "./EventMailTable.vue?vue&type=template&id=33c5db1d"
import script from "./EventMailTable.vue?vue&type=script&lang=js"
export * from "./EventMailTable.vue?vue&type=script&lang=js"
import style0 from "./EventMailTable.vue?vue&type=style&index=0&id=33c5db1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports